exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apple-pay-container[data-v-6f33cc32] {\n  padding: 10px;\n}", ""]);

// exports
